
























// Libraries
import { Component, Vue } from "vue-property-decorator";
// Types
import { Quote } from "@/types/quote";
// Components
import SingleQuote from "@/components/SingleQuote.vue";
import NoDataIcon from "@/assets/scss/svg-icons/NoDataIcon.vue";

@Component({
  components: {
    SingleQuote,
    NoDataIcon,
  },
})
export default class QuotesWrapper extends Vue {
  get quotes(): Quote[] | null {
    return this.$store.state.quotes;
  }

  created(): void {
    this.$store.dispatch("fetchQuotes");
  }
}
